import { createNamedContext } from '@trinity/chat-components';
import type { TranscriptLockContextValue, TranscriptRedactingContextValue } from './interfaces';

export const TranscriptRedactingContext = createNamedContext<TranscriptRedactingContextValue>(undefined, 'Transcript.Redaction.Redacting.Context');
export const TranscriptLockContext = createNamedContext<TranscriptLockContextValue>(undefined, 'Transcript.Redaction.Lock.Context');